(function () {
  var sectionState = new WeakMap();

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function lerp(start, end, amount) {
    return start + ((end - start) * amount);
  }

  function ease(value) {
    return value < 0.5
      ? 4 * value * value * value
      : 1 - Math.pow(-2 * value + 2, 3) / 2;
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function deriveSiteLabel(title, domain) {
    var rules = [
      { pattern: /6moons/i, label: '6Moons' },
      { pattern: /stereophile/i, label: 'Stereophile' },
      { pattern: /enjoythemusic/i, label: 'Enjoy the Music' },
      { pattern: /wallofsound/i, label: 'Wall of Sound' }
    ];

    for (var index = 0; index < rules.length; index += 1) {
      if (rules[index].pattern.test(title) || rules[index].pattern.test(domain)) {
        return rules[index].label;
      }
    }

    if (domain) {
      return domain
        .replace(/^www\./i, '')
        .split('.')[0]
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, function (char) { return char.toUpperCase(); });
    }

    return title.replace(/\b20\d{2}\b/g, '').trim() || 'Press';
  }

  function deriveMonogram(label) {
    var words = label.replace(/&/g, ' ').split(/\s+/).filter(Boolean);

    if (!words.length) return 'PR';
    if (/^\d/.test(words[0])) return words[0].slice(0, 2).toUpperCase();
    if (words.length === 1) return words[0].slice(0, 3).toUpperCase();

    return words.slice(0, 3).map(function (word) {
      return word.charAt(0).toUpperCase();
    }).join('');
  }

  function shortenQuote(quote) {
    if (quote.length <= 340) return quote;
    return quote.slice(0, 337).trim() + '...';
  }

  function readLogoMap(section) {
    var logoMapEl = section.querySelector('[data-press-logo-map]');
    if (!logoMapEl) return {};

    try {
      return JSON.parse(logoMapEl.textContent || '{}') || {};
    } catch (error) {
      return {};
    }
  }

  function readReviews(source, logoMap) {
    var reviews = [];
    var headings = source.querySelectorAll('h5');

    Array.prototype.forEach.call(headings, function (heading) {
      var link = heading.querySelector('a');
      var body = heading.nextElementSibling;

      if (!link || !body || body.tagName !== 'P') return;

      var clone = body.cloneNode(true);
      var authorNodes = clone.querySelectorAll('strong');
      var authorNode = authorNodes.length ? authorNodes[authorNodes.length - 1] : null;
      var author = authorNode
        ? authorNode.textContent.replace(/^\s*[-\u2013\u2014]\s*/, '').trim()
        : '';

      if (authorNode) authorNode.remove();

      var quote = clone.textContent
        .replace(/\s+/g, ' ')
        .replace(/^\s*["'\u201C\u201D\u2018\u2019]+|["'\u201C\u201D\u2018\u2019]+\s*$/g, '')
        .replace(/\s*[-\u2013\u2014]\s*$/, '')
        .trim();

      if (!quote) return;

      var domain = '';
      try {
        domain = new URL(link.href).hostname.replace(/^www\./i, '');
      } catch (error) {
        domain = '';
      }

      var title = link.textContent.trim();
      var siteLabel = deriveSiteLabel(title, domain);
      var yearMatch = title.match(/\b(20\d{2})\b/);

      reviews.push({
        title: title,
        href: link.href,
        quote: quote,
        shortQuote: shortenQuote(quote),
        author: author,
        siteLabel: siteLabel,
        siteMonogram: deriveMonogram(siteLabel),
        logoUrl: logoMap[siteLabel] || '',
        domainDisplay: domain || 'Original publication',
        year: yearMatch ? yearMatch[1] : ''
      });
    });

    return reviews;
  }

  function removeAttributionDash(authorNode) {
    var previous = authorNode.previousSibling;

    while (previous && previous.nodeType === 1 && previous.tagName === 'BR') {
      previous = previous.previousSibling;
    }

    if (previous && previous.nodeType === 3) {
      previous.textContent = previous.textContent.replace(/\s*[-\u2013\u2014]\s*$/, ' ');
    }
  }

  function enhanceFallbackCards(source, reviews) {
    if (source.dataset.pressFallbackEnhanced === 'true') return;

    var headings = source.querySelectorAll('h5');

    Array.prototype.forEach.call(headings, function (heading, index) {
      var review = reviews[index];
      var link = heading.querySelector('a');
      var body = heading.nextElementSibling;

      if (link) {
        link.classList.add('press-fallback__title');
      }

      if (review && review.logoUrl && !heading.querySelector('.review-card__logo')) {
        var logo = document.createElement('img');
        logo.className = 'review-card__logo review-card__logo--fallback';
        logo.src = review.logoUrl;
        logo.alt = review.siteLabel + ' logo';
        logo.loading = 'lazy';
        heading.insertBefore(logo, link || heading.firstChild);
      }

      if (!body || body.tagName !== 'P') return;

      var strongs = body.querySelectorAll('strong');
      if (!strongs.length) return;

      Array.prototype.forEach.call(strongs, function (strong) {
        strong.classList.add('press-fallback__highlight');
      });

      var authorNode = strongs[strongs.length - 1];
      var authorText = authorNode.textContent.replace(/^\s*[-\u2013\u2014]\s*/, '').trim();

      if (!authorText) return;

      removeAttributionDash(authorNode);
      authorNode.classList.remove('press-fallback__highlight');
      authorNode.classList.add('press-fallback__author');
      authorNode.textContent = '\u2013 ' + authorText;
    });

    source.dataset.pressFallbackEnhanced = 'true';
  }

  function buildCards(track, reviews) {
    track.innerHTML = reviews.map(function (review) {
      return [
        '<a class="review-card" href="' + review.href + '" target="_blank" rel="noopener noreferrer">',
        '<div class="review-card__preview">',
        '<div class="review-card__chrome">',
        '<span class="review-card__dots" aria-hidden="true"><span></span><span></span><span></span></span>',
        '<span>' + escapeHtml(review.domainDisplay) + '</span>',
        '</div>',
        '<div class="review-card__mark">',
        review.logoUrl
          ? '<img class="review-card__logo" src="' + escapeHtml(review.logoUrl) + '" alt="' + escapeHtml(review.siteLabel) + ' logo" loading="lazy">'
          : '<span class="review-card__monogram">' + escapeHtml(review.siteMonogram) + '</span>',
        '<span class="review-card__site">' + escapeHtml(review.siteLabel) + '</span>',
        '<span class="review-card__domain">' + escapeHtml(review.domainDisplay) + '</span>',
        '</div>',
        '</div>',
        '<div class="review-card__body">',
        '<div>',
        '<div class="review-card__meta">',
        '<span>' + escapeHtml(review.title) + '</span>',
        '<span>' + escapeHtml(review.year || 'Press note') + '</span>',
        '</div>',
        '<h3 class="review-card__title">' + escapeHtml(review.title) + '</h3>',
        '<p class="review-card__quote">"' + escapeHtml(review.shortQuote) + '"</p>',
        (review.author ? '<span class="review-card__author">' + escapeHtml(review.author) + '</span>' : ''),
        '</div>',
        '<span class="review-card__link">Open original review</span>',
        '</div>',
        '</a>'
      ].join('');
    }).join('');
  }

  function getYearRange(reviews) {
    var years = reviews
      .map(function (review) { return parseInt(review.year, 10); })
      .filter(function (year) { return !isNaN(year); })
      .sort(function (left, right) { return left - right; });

    if (!years.length) return '';
    if (years[0] === years[years.length - 1]) return String(years[0]);
    return years[0] + '-' + years[years.length - 1];
  }

  function updateCardStyles(state, activeFloat) {
    Array.prototype.forEach.call(state.cards, function (card, index) {
      var signedDistance = index - activeFloat;
      var distance = Math.abs(signedDistance);
      var intensity = clamp(1 - (distance / 1.15), 0, 1);
      var drift = clamp(distance, 0, 1.45) * 28;
      var lift = signedDistance < 0 ? -drift : drift;
      var isActive = distance < 0.55;
      var scale = isActive ? 1 : 0.9 + (intensity * 0.1);
      var opacity = isActive ? 1 : 0.14 + (intensity * 0.7);
      var blur = (1 - intensity) * 1.35;

      card.style.opacity = opacity.toFixed(3);
      card.style.transform = 'translate3d(0,' + lift.toFixed(1) + 'px,0) scale(' + scale.toFixed(3) + ')';
      card.style.filter = 'blur(' + (isActive ? 0 : blur).toFixed(2) + 'px)';
      card.classList.toggle('is-active', isActive);
    });
  }

  function scheduleUpdate(section) {
    var state = sectionState.get(section);
    if (!state || state.frame) return;

    state.frame = window.requestAnimationFrame(function () {
      state.frame = null;
      updateSection(section);
    });
  }

  function scheduleMeasure(section) {
    var state = sectionState.get(section);
    if (!state || state.measureFrame) return;

    state.measureFrame = window.requestAnimationFrame(function () {
      state.measureFrame = null;
      measureSection(section);
    });
  }

  function updateSection(section) {
    var state = sectionState.get(section);
    if (!state || !state.motionTranslations.length) return;

    var scrollRange = Math.max(state.story.offsetHeight - state.stage.offsetHeight, 0);
    var storyRect = state.story.getBoundingClientRect();
    var maxIndex = state.reviews.length - 1;
    var motionMaxIndex = state.motionTranslations.length - 1;
    var rawDistance = clamp(-storyRect.top, 0, scrollRange);
    var usableRange = Math.max(scrollRange - state.entryOffset - state.exitOffset, 1);
    var progress = clamp((rawDistance - state.entryOffset) / usableRange, 0, 1);
    var motionFloat = motionMaxIndex > 0 ? progress * motionMaxIndex : 0;
    var activeFloat = Math.min(motionFloat, maxIndex);
    var startIndex = Math.floor(motionFloat);
    var endIndex = Math.min(motionMaxIndex, startIndex + 1);
    var localProgress = motionMaxIndex > 0 ? motionFloat - startIndex : 0;
    var translation = state.motionTranslations[0];

    if (motionMaxIndex > 0) {
      translation = lerp(
        state.motionTranslations[startIndex],
        state.motionTranslations[endIndex],
        ease(localProgress)
      );
    }

    state.track.style.transform = 'translate3d(0,' + translation.toFixed(2) + 'px,0)';
    state.progress.style.transform = 'scaleX(' + progress.toFixed(4) + ')';

    updateCardStyles(state, activeFloat);

    var activeIndex = clamp(Math.round(activeFloat), 0, maxIndex);
    var activeReview = state.reviews[activeIndex];

    if (!activeReview) return;

    state.current.textContent = pad(activeIndex + 1);
    if (state.lastActiveIndex !== activeIndex) {
      state.source.textContent = activeReview.siteLabel;
      state.domain.textContent = activeReview.domainDisplay;
      state.activeTitle.textContent = activeReview.title;
      state.activeAuthor.textContent = activeReview.author || 'Original publication';
      state.lastActiveIndex = activeIndex;
    }
  }

  function measureSection(section) {
    var state = sectionState.get(section);
    if (!state || !state.cards.length) return;

    var firstCard = state.cards[0];
    var lastCard = state.cards[state.cards.length - 1];
    var windowHeight = state.windowEl.clientHeight;
    var focusTop = clamp(windowHeight * 0.07, 26, 54);
    var paddingTop = focusTop;
    // Keep the bottom pad small — the stage is now content-sized, so a large
    // bottom pad would re-introduce the trailing dead space below the last card.
    var paddingBottom = focusTop + 12;
    var entryOffset = clamp(windowHeight * 0.045, 24, 42);
    var exitOffset = clamp(windowHeight * 0.04, 20, 38);

    state.track.style.transform = 'translate3d(0,0,0)';
    state.track.style.paddingTop = paddingTop + 'px';
    state.track.style.paddingBottom = paddingBottom + 'px';

    state.stepTranslations = state.cards.map(function (card) {
      return focusTop - card.offsetTop;
    });

    var measuredSteps = [];
    for (var index = 1; index < state.cards.length; index += 1) {
      measuredSteps.push(state.cards[index].offsetTop - state.cards[index - 1].offsetTop);
    }

    var averageStep = measuredSteps.length
      ? measuredSteps.reduce(function (sum, value) { return sum + value; }, 0) / measuredSteps.length
      : firstCard.offsetHeight;
    var stepDistance = clamp(averageStep * 1.15, 240, 340);

    state.entryOffset = entryOffset;
    state.exitOffset = exitOffset;
    // Stop motion exactly at the last review — no trailing exit translation,
    // so the section ends right after the final card is centered.
    state.motionTranslations = state.stepTranslations.slice();

    state.story.style.height = Math.ceil(
      state.stage.offsetHeight
      + entryOffset
      + exitOffset
      + (stepDistance * Math.max(state.cards.length - 1, 1))
    ) + 'px';

    updateSection(section);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;

    if (state.frame) {
      window.cancelAnimationFrame(state.frame);
    }
    if (state.measureFrame) {
      window.cancelAnimationFrame(state.measureFrame);
    }
    if (state.remeasureTimer) {
      window.clearTimeout(state.remeasureTimer);
    }
    if (state.resizeObserver) {
      state.resizeObserver.disconnect();
    }

    window.removeEventListener('scroll', state.scrollHandler);
    window.removeEventListener('resize', state.resizeHandler);
    state.mediaQuery.removeEventListener('change', state.mediaQueryHandler);

    state.root.removeAttribute('data-enhanced');
    state.story.hidden = true;
    state.story.style.height = '';
    state.track.style.transform = '';
    state.track.style.paddingTop = '';
    state.track.style.paddingBottom = '';
    state.track.innerHTML = '';
    state.progress.style.transform = '';
    sectionState.delete(section);
  }

  function mountSection(section) {
    destroySection(section);

    var root = section.querySelector('[data-press-root]');
    var source = section.querySelector('[data-press-source-content]');
    var story = section.querySelector('[data-press-story]');
    var stage = section.querySelector('[data-press-stage]');
    var windowEl = section.querySelector('[data-press-window]');
    var track = section.querySelector('[data-press-track]');
    var progress = section.querySelector('[data-press-progress]');
    var current = section.querySelector('[data-press-current]');
    var total = section.querySelector('[data-press-total]');
    var totalInline = section.querySelector('[data-press-total-inline]');
    var years = section.querySelector('[data-press-years]');
    var activeTitle = section.querySelector('[data-press-active-title]');
    var activeAuthor = section.querySelector('[data-press-active-author]');
    var sourceLabel = section.querySelector('[data-press-source]');
    var sourceDomain = section.querySelector('[data-press-domain]');

    if (!root || !source || !story || !stage || !windowEl || !track || !progress) return;

    var reviews = readReviews(source, readLogoMap(section));
    var mediaQuery = window.matchMedia('(max-width: 989px), (prefers-reduced-motion: reduce)');

    if (reviews.length < 2) return;

    enhanceFallbackCards(source, reviews);

    if (total) total.textContent = pad(reviews.length);
    if (totalInline) totalInline.textContent = pad(reviews.length) + ' reviews';
    if (years) {
      var yearRange = getYearRange(reviews);
      if (yearRange) years.textContent = yearRange;
    }

    if (mediaQuery.matches) return;

    buildCards(track, reviews);
    story.hidden = false;
    root.setAttribute('data-enhanced', 'true');

    var cards = Array.prototype.slice.call(track.querySelectorAll('.review-card'));

    var scrollHandler = function () {
      scheduleUpdate(section);
    };

    var resizeHandler = function () {
      scheduleMeasure(section);
    };

    var mediaQueryHandler = function (event) {
      if (event.matches) {
        destroySection(section);
      } else {
        mountSection(section);
      }
    };

    sectionState.set(section, {
      root: root,
      story: story,
      stage: stage,
      windowEl: windowEl,
      track: track,
      progress: progress,
      current: current,
      total: total,
      activeTitle: activeTitle,
      activeAuthor: activeAuthor,
      source: sourceLabel,
      domain: sourceDomain,
      reviews: reviews,
      cards: cards,
      stepTranslations: [],
      motionTranslations: [],
      entryOffset: 0,
      exitOffset: 0,
      resizeObserver: null,
      remeasureTimer: null,
      lastActiveIndex: -1,
      mediaQuery: mediaQuery,
      mediaQueryHandler: mediaQueryHandler,
      scrollHandler: scrollHandler,
      resizeHandler: resizeHandler,
      frame: null,
      measureFrame: null
    });

    window.addEventListener('scroll', scrollHandler, { passive: true });
    window.addEventListener('resize', resizeHandler);
    mediaQuery.addEventListener('change', mediaQueryHandler);

    measureSection(section);

    var state = sectionState.get(section);
    if (!state) return;

    state.remeasureTimer = window.setTimeout(function () {
      scheduleMeasure(section);
    }, 180);

    if (typeof ResizeObserver === 'function') {
      state.resizeObserver = new ResizeObserver(function () {
        scheduleMeasure(section);
      });

      state.cards.forEach(function (card) {
        state.resizeObserver.observe(card);
      });
    }

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(function () {
        scheduleMeasure(section);
      });
    }
  }

  function init() {
    var sections = document.querySelectorAll('[id^="ShowReportsLuxury-"]');

    if (!sections.length) return;

    Array.prototype.forEach.call(sections, function (section) {
      mountSection(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.matches('[id^="ShowReportsLuxury-"]')
      ? event.target
      : event.target && event.target.querySelector
        ? event.target.querySelector('[id^="ShowReportsLuxury-"]')
        : null;

    if (!section) return;
    mountSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.matches('[id^="ShowReportsLuxury-"]')
      ? event.target
      : event.target && event.target.querySelector
        ? event.target.querySelector('[id^="ShowReportsLuxury-"]')
        : null;

    if (!section) return;
    destroySection(section);
  });
})();
